// const baseUrl = process.env.NODE_ENV === "development" 
// ? 'http://10.118.104.29:5000' 
// : 'http://10.118.104.29:5000';

// export default baseUrl;
// REACT_APP_API=/api

const baseUrl = "/api"; // always production

export default baseUrl;
